// TelcoTrack — jednoklikové DOSS / Úřady po trase (návrh z mapy + katalog).

export type AuthorityAutoDossBlockerCode =
  | 'no_route'
  | 'propose_organs_failed'
  | 'propose_networks_failed'
  | 'catalog_failed'
  | 'contact_gap'
  | 'skipped_layers';

export interface AuthorityAutoDossBlocker {
  code: AuthorityAutoDossBlockerCode;
  messageCs: string;
  subjectKey?: string;
  layerId?: string;
}

export interface AuthorityAutoDossReport {
  applied: boolean;
  organsCreated: number;
  networksCreated: number;
  catalogCreated: number;
  catalogSkipped: number;
  blockers: AuthorityAutoDossBlocker[];
  error: string | null;
}

export function skippedAuthorityAutoDossReport(): AuthorityAutoDossReport {
  return {
    applied: false,
    organsCreated: 0,
    networksCreated: 0,
    catalogCreated: 0,
    catalogSkipped: 0,
    blockers: [],
    error: null,
  };
}

export function failedAuthorityAutoDossReport(error: string): AuthorityAutoDossReport {
  return {
    applied: false,
    organsCreated: 0,
    networksCreated: 0,
    catalogCreated: 0,
    catalogSkipped: 0,
    blockers: [],
    error: error.trim() || 'Automatické dohledání orgánů selhalo.',
  };
}

export function formatAuthorityAutoDossReportCs(report: AuthorityAutoDossReport | null | undefined): string {
  if (!report?.applied && !report?.error && !report?.blockers?.length) return '';
  if (report?.error) return `Úřady (auto): ${report.error}`;
  const parts: string[] = [];
  if (report.organsCreated > 0 || report.networksCreated > 0) {
    parts.push(
      `orgány +${report.organsCreated}, sítě +${report.networksCreated}`,
    );
  }
  if (report.catalogCreated > 0 || report.catalogSkipped > 0) {
    parts.push(`katalog +${report.catalogCreated} (přeskočeno ${report.catalogSkipped})`);
  }
  const blockers = report.blockers?.length ?? 0;
  if (blockers > 0) parts.push(`${blockers} položek vyžaduje doplnění`);
  return parts.length ? `Úřady (auto): ${parts.join('; ')}.` : 'Úřady (auto): dokončeno.';
}

export async function runAuthorityAutoDossIfRequested(
  flag: boolean | null | undefined,
  run: () => Promise<AuthorityAutoDossReport>,
): Promise<AuthorityAutoDossReport> {
  if (flag !== true) return skippedAuthorityAutoDossReport();
  try {
    return await run();
  } catch (err) {
    const message = err instanceof Error ? err.message : String(err);
    return failedAuthorityAutoDossReport(message);
  }
}
